interface LogoIconProps {
  size?: number;
}

export function LogoIcon({ size = 18 }: LogoIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none">
      <rect x="2"  y="2"  width="13" height="13" rx="3" fill="white" />
      <rect x="21" y="2"  width="13" height="13" rx="3" fill="white" />
      <rect x="2"  y="21" width="13" height="13" rx="3" fill="white" />
      <rect x="21" y="21" width="13" height="13" rx="3" fill="white" opacity="0.4" />
    </svg>
  );
}
